import * as API from '@/api'

function initialState() {
    return {};
}

const state = initialState();

// actions
const actions = {
    async fetchEntityUserCount(context,payload) {
        var response = await API.analytics.fetchEntityUserCount(payload)
        return response;
    },

    async fetchFilmWatchTime(context,payload) {
        var response = await API.analytics.fetchFilmWatchTime(payload)
        return response;
    },

    async fetchEntityOverviewData(context,payload) {
        var response = await API.analytics.fetchEntityOverviewData(payload)
        return response;
    },

    async fetchConsumerAnalyticsOnFilm(context,payload) {
        var response = await API.analytics.fetchConsumerAnalyticsOnFilm(payload)
        return response;
    }
}

// getters
const getters = {};

// mutations
const mutations = {
    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
          state[key] = s[key];
        });
    },

}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
